import type {
  CharacteristicGroup,
  ComparisonCharacteristics,
  ComparisonObject,
} from "./comparison-data-service";

export function getCharacteristicGroups(
  characteristics: ComparisonCharacteristics[] | undefined,
): CharacteristicGroup[] {
  if (!characteristics) {
    return [];
  }

  return characteristics.flatMap((groupRecord) => Object.values(groupRecord));
}

export function getCategoryForObject(
  obj: ComparisonObject,
  categoryName: string,
): CharacteristicGroup | undefined {
  return getCharacteristicGroups(obj.characteristics?.value).find(
    (c) => c.Formatted_name === categoryName,
  );
}

export function formatAttributeValue(
  value: string | null | undefined,
  datatype: "numeric" | "string" | "percentage" | undefined,
): string {
  if (!value) return "–";
  if (datatype === "numeric") {
    const num = parseFloat(value);
    return isNaN(num) ? value : num.toLocaleString();
  }
  if (datatype === "percentage") {
    const num = parseFloat(value) / 100;
    return isNaN(num)
      ? value
      : num.toLocaleString(undefined, {
          style: "percent",
          maximumFractionDigits: 2,
        });
  }
  return value;
}

export function getCharacteristicDescription(
  objects: ComparisonObject[],
  categoryName: string,
  characteristicName: string,
): string | undefined {
  for (const obj of objects) {
    const child = getCategoryForObject(obj, categoryName)?.Attributes.find(
      (c) => c.name === characteristicName,
    );
    if (child?.meta?.description) {
      return child.meta.description;
    }
  }
  return undefined;
}
